import React, { useContext, useEffect, useState } from 'react';
import { deleteSavedContact, savedContactList } from '../../../api/privateApis';
import PageSizeDropdown from '../../global-components/pageSizeDropDown';
import SearchField from '../../global-components/searchField';
import AlertModal from '../../global-components/alertModal';
import AddSavedContactModal from './addSavedContactModal';
import PaginationContainer from '../../global-components/pagination';
import { AbilityContext } from '../../../context/AbilityContext';
import { useSnackbar } from 'notistack';
import ImportAddressModal from '../saved-address/importAddressModal';
import { useLocation } from 'react-router-dom';
import editIcon from '../../../assets/icons/new_icon/edit-2.svg';
import deleteIcon from '../../../assets/icons/new_icon/delete-2.svg';
import check from '../../../assets/icons/new_icon/correct.svg';
import cross from '../../../assets/icons/new_icon/delcross.svg';
import NewPaginationContainer from '../../global-components/new-pagination';
import plusIcon from '../../../assets/icons/new_icon/plus-icon.svg';
import downloadIconBlue from '../../../assets/icons/new_icon/document-upload.svg';
import ImportIconBlue from '../../../assets/icons/new_icon/document-download.svg';
import PageToolbar from '../../global-components/pageToolbar';
import AddButton from '../../global-components/AddButton';
import { deleteAllContact } from '../../../api/multiSelect';

function SavedContacts(props?: any) {
  const ability = useContext(AbilityContext);
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const user = new URLSearchParams(location.search).get('user');
  const account = new URLSearchParams(location.search).get('account_number');
  const [savedContactData, setSavedContactData] = useState<any>();
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState('');
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showAllDeleteAlert, setShowAllDeleteAlert] = useState(false);

  const [showImportModal, setShowImportModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [editData, setEditData] = useState<any>(null);
  const [pageSize, setPageSize] = useState<number>(25);
  const pageSizeOptions: number[] = [25, 50, 75, 100, 125];
  const [selectedItems, setSelectedItems] = useState<any>([]);

  const fetchData = (searchText?: string) => {
    let payload = {
      page: currentPage,
      pageSize: pageSize,
      search: searchText ? searchText : '',
      username: user,
      account_number: account,
    };
    setLoading(true);
    savedContactList(payload)
      .then((response: any) => {
        if (!response?.data?.is_error) {
          setSavedContactData(response?.data?.content);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize]);
  const handleSearchField = (query: string) => {
    fetchData(query);
  };
  function deleteContact(id: any) {
    deleteSavedContact(id)
      .then((response) => {
        if (!response?.data?.is_error) {
          fetchData();
          enqueueSnackbar('Contact has been deleted', { variant: 'success' });
        }
        setShowDeleteAlert(false);
        setSelectedItems([]);
      })
      .catch((e) => {
        setShowDeleteAlert(false);
      });
  }
  function onCloseModal() {
    setShowAddModal(false);
    setShowEditModal(false);
    setEditData(null);
    setSelectedItemId('');
  }
  const handleSelectAll = () => {
    // Check if all items are already selected
    const allSelected = selectedItems.length === savedContactData?.data?.length;

    if (allSelected) {
      // If all items are selected, unselect all items
      setSelectedItems([]);
    } else {
      // Otherwise, select all items
      const allItemIds = savedContactData?.data.map((item: any) => item.id);
      setSelectedItems(allItemIds);
    }
  };

  const handleSelectItem = (itemId: any) => {
    // Logic to select/deselect individual item
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id: any) => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };
  function handleDeleteAll() {
    const transformedObject = {
      ids: selectedItems,
    };
    deleteAllContact(transformedObject)
      .then((response: any) => {
        if (!response?.data?.is_error) {
          setCurrentPage(1);
          fetchData();
          setSelectedItems([]);
          enqueueSnackbar('All selected contacts have been deleted.', {
            variant: 'success',
          });
        }
        setShowAllDeleteAlert(false);
      })
      .catch((e: any) => {
        setShowAllDeleteAlert(false);
      });
  }
  return (
    <div className='container-fluid mt-2 my-4'>
      <div
        className='row mb-5'
        style={props?.otherSection ? { marginTop: '-100px' } : undefined}
      >
        <div className='col-12'>
          <div className='card-body  p-4'>
            <PageToolbar
              handleSearchField={handleSearchField}
              setSearchQuery={setSearchTerm}
              searchText={searchTerm}
              title={props.otherSection ? 'Contacts' : ''}
            >
              {!user && (
                <div className='d-flex align-items-center   text-end'>
                  {selectedItems?.length > 0 && (
                    <button
                      type='button'
                      className='btn btn-ubbe-danger '
                      data-bs-toggle='modal'
                      data-bs-target='#saved_address_modal'
                      onClick={() => setShowAllDeleteAlert(true)}
                    >
                      <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <rect
                          x='6.53906'
                          y='8.36523'
                          width='6.53854'
                          height='6.53854'
                          fill='white'
                        />
                        <path
                          d='M4.90325 15.7216C4.90325 16.6207 5.63884 17.3562 6.53789 17.3562H13.0764C13.9755 17.3562 14.7111 16.6207 14.7111 15.7216V5.9138H4.90325V15.7216ZM7.49415 10.4826C7.34133 10.3298 7.25548 10.1225 7.25548 9.90639C7.25548 9.69027 7.34133 9.48301 7.49415 9.33019C7.64697 9.17737 7.85424 9.09151 8.07036 9.09151C8.28648 9.09151 8.49375 9.17737 8.64657 9.33019L9.80716 10.4826L10.9596 9.33019C11.1124 9.17737 11.3197 9.09151 11.5358 9.09151C11.7519 9.09151 11.9592 9.17737 12.112 9.33019C12.2648 9.48301 12.3507 9.69027 12.3507 9.90639C12.3507 10.1225 12.2648 10.3298 12.112 10.4826L10.9596 11.635L12.112 12.7874C12.1877 12.8631 12.2477 12.9529 12.2886 13.0518C12.3296 13.1507 12.3507 13.2566 12.3507 13.3636C12.3507 13.4707 12.3296 13.5766 12.2886 13.6755C12.2477 13.7744 12.1877 13.8642 12.112 13.9399C12.0363 14.0155 11.9465 14.0755 11.8476 14.1165C11.7488 14.1574 11.6428 14.1785 11.5358 14.1785C11.4288 14.1785 11.3228 14.1574 11.2239 14.1165C11.1251 14.0755 11.0352 14.0155 10.9596 13.9399L9.80716 12.7874L8.65474 13.9399C8.57907 14.0155 8.48924 14.0755 8.39037 14.1165C8.29151 14.1574 8.18554 14.1785 8.07853 14.1785C7.97152 14.1785 7.86556 14.1574 7.76669 14.1165C7.66782 14.0755 7.57799 14.0155 7.50232 13.9399C7.42665 13.8642 7.36663 13.7744 7.32568 13.6755C7.28473 13.5766 7.26365 13.4707 7.26365 13.3636C7.26365 13.2566 7.28473 13.1507 7.32568 13.0518C7.36663 12.9529 7.42665 12.8631 7.50232 12.7874L8.65474 11.635L7.49415 10.4826ZM14.7111 3.46185H12.6678L12.0875 2.88155C11.9404 2.73444 11.7279 2.64453 11.5154 2.64453H8.09896C7.88646 2.64453 7.67396 2.73444 7.52684 2.88155L6.94655 3.46185H4.90325C4.45373 3.46185 4.08594 3.82964 4.08594 4.27917C4.08594 4.72869 4.45373 5.09648 4.90325 5.09648H14.7111C15.1606 5.09648 15.5284 4.72869 15.5284 4.27917C15.5284 3.82964 15.1606 3.46185 14.7111 3.46185Z'
                          fill='white'
                        />
                      </svg>
                      Delete
                    </button>
                  )}
                  <a
                    className='btn btn-ubbe-ghost mb_0 cursor_pointer'
                    style={{ marginRight: 20 }}
                    href={require('../../../assets/excel/contact_template.xlsx')}
                  >
                    <img
                      src={ImportIconBlue}
                      alt='doc-download-icon'
                      className='me-1'
                    />
                    Download Template
                  </a>
                  {ability?.can('create', 'Saved Contact') && (
                    <button
                      type='button'
                      className='btn btn-ubbe-secondary'
                      data-bs-toggle='modal'
                      data-bs-target='#address_upload_modal'
                      style={{ marginRight: 20 }}
                      onClick={() => {
                        setShowImportModal(true);
                      }}
                    >
                      <span className='me-1 mb-1'>
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M15.1579 6.552H12.7242C10.7284 6.552 9.10316 5.008 9.10316 3.112V0.8C9.10316 0.36 8.72421 0 8.26105 0H4.69053C2.09684 0 0 1.6 0 4.456V11.544C0 14.4 2.09684 16 4.69053 16H11.3095C13.9032 16 16 14.4 16 11.544V7.352C16 6.912 15.6211 6.552 15.1579 6.552ZM7.60421 9.224C7.47789 9.344 7.31789 9.4 7.15789 9.4C6.99789 9.4 6.83789 9.344 6.71158 9.224L6.10526 8.648V12C6.10526 12.328 5.81895 12.6 5.47368 12.6C5.12842 12.6 4.84211 12.328 4.84211 12V8.648L4.23579 9.224C3.99158 9.456 3.58737 9.456 3.34316 9.224C3.09895 8.992 3.09895 8.608 3.34316 8.376L5.02737 6.776C5.08632 6.728 5.14526 6.688 5.21263 6.656C5.22947 6.648 5.25474 6.64 5.27158 6.632C5.32211 6.616 5.37263 6.608 5.43158 6.6C5.45684 6.6 5.47368 6.6 5.49895 6.6C5.56632 6.6 5.63368 6.616 5.70105 6.64C5.70947 6.64 5.70947 6.64 5.71789 6.64C5.78526 6.664 5.85263 6.712 5.90316 6.76C5.91158 6.768 5.92 6.768 5.92 6.776L7.60421 8.376C7.84842 8.608 7.84842 8.992 7.60421 9.224Z'
                            fill='#251163'
                            className='request-quote-icon-path'
                          />
                          <path
                            d='M12.5731 5.4476C13.3731 5.4556 14.4847 5.4556 15.4363 5.4556C15.9163 5.4556 16.1689 4.9196 15.8321 4.5996C14.6194 3.4396 12.4468 1.3516 11.2005 0.167604C10.8552 -0.160396 10.2573 0.0636039 10.2573 0.519604V3.3116C10.2573 4.4796 11.3015 5.4476 12.5731 5.4476Z'
                            fill='#251163'
                            className='request-quote-icon-path'
                          />
                        </svg>
                      </span>
                      Import
                    </button>
                  )}
                  {ability?.can('create', 'Saved Contact') && (
                    <AddButton
                      clickHandler={() => {
                        setShowAddModal(true);
                      }}
                    />
                  )}
                </div>
              )}
              {props.setShowAddContactModal && (
                <AddButton
                  clickHandler={() => props.setShowAddContactModal(true)}
                />
              )}
            </PageToolbar>

            <div className='mt-4 overflow-auto'>
              <table
                className='table'
                id='saved_quote_table'
              >
                <thead className='position-sticky top-0 ubbe-table-header'>
                  <tr>
                    {!props.otherSection && (
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        style={{ width: '5%' }}
                        scope='col'
                      >
                        <div className='form-check  d-flex justify-content-center '>
                          <input
                            type='checkbox'
                            className='form-check-input globalInputLabel cursor_pointer'
                            onChange={handleSelectAll}
                            checked={
                              savedContactData?.data?.length > 0
                                ? selectedItems?.length ===
                                  savedContactData?.data?.length
                                : false
                            }
                          />
                        </div>
                      </th>
                    )}
                    <th
                      scope='col'
                      style={{ width: '10%' }}
                      className={`text-start align-middle ubbe-table-heading-text`}
                    >
                      Company
                    </th>
                    <th
                      scope='col'
                      style={{ width: '15%' }}
                      className={`text-start align-middle ubbe-table-heading-text`}
                    >
                      Name
                    </th>
                    <th
                      scope='col'
                      style={{ width: '15%' }}
                      className={`text-start align-middle ubbe-table-heading-text`}
                    >
                      Email Address
                    </th>
                    <th
                      scope='col'
                      style={{ width: '15%' }}
                      className={`text-start align-middle ubbe-table-heading-text`}
                    >
                      Phone Number
                    </th>
                    <th
                      scope='col'
                      style={{ width: '10%' }}
                      className={`text-center align-middle ubbe-table-heading-text`}
                    >
                      Origin
                    </th>
                    <th
                      scope='col'
                      className={`text-center align-middle ubbe-table-heading-text`}
                    >
                      Destination
                    </th>
                    {ability?.can('edit', 'Saved Contact') && (
                      <th scope='col'></th>
                    )}
                    {ability?.can('delete', 'Saved Contact') && (
                      <th scope='col'></th>
                    )}
                  </tr>
                </thead>
                <tbody
                  id='saved_contact_rows'
                  className='legs'
                >
                  {savedContactData && savedContactData?.data.length > 0 ? (
                    savedContactData?.data.map((item: any) => (
                      <tr>
                        {!props.otherSection && (
                          <td className='align-middle'>
                            <div
                              className='form-check d-flex justify-content-center '
                              style={{ marginLeft: '3px' }}
                            >
                              <input
                                type='checkbox'
                                className='form-check-input globalInputLabel cursor_pointer'
                                checked={selectedItems.includes(item.id)}
                                onChange={() => handleSelectItem(item.id)}
                              />
                            </div>
                          </td>
                        )}
                        <td className='align-middle'>
                          {item?.contact?.company_name}
                        </td>
                        <td className='align-middle'>{item?.contact?.name}</td>
                        <td className='align-middle'>{item?.contact?.email}</td>
                        <td className='align-middle'>{item?.contact?.phone}</td>
                        <td className='align-middle'>
                          {item?.is_origin ? (
                            <img
                              src={check}
                              style={{
                                width: '25px',
                              }}
                              className='m-auto d-flex '
                            />
                          ) : (
                            <img
                              src={cross}
                              style={{
                                width: '25px',
                              }}
                              className='m-auto d-flex '
                            />
                          )}
                        </td>
                        <td className='align-middle'>
                          {item?.is_destination ? (
                            <img
                              src={check}
                              style={{
                                width: '25px',
                              }}
                              className='m-auto d-flex '
                            />
                          ) : (
                            <img
                              src={cross}
                              className='m-auto d-flex '
                            />
                          )}
                        </td>
                        <td className='align-middle'></td>
                        {(ability.can('edit', 'Saved Contact') ||
                          ability.can('delete', 'Saved Contact')) && (
                          <>
                            <td
                              className='align-middle text-center'
                              style={{ width: '10%' }}
                            >
                              <span
                                className='btn-ubbe-no-style'
                                onClick={() => {
                                  setEditData(item);
                                  setShowEditModal(true);
                                }}
                              >
                                <img
                                  alt='delete-icon'
                                  src={editIcon}
                                  className='packageBoxIcon'
                                  style={{
                                    backgroundColor: 'rgba(26, 97, 204, 0.10)',
                                    cursor: 'pointer',
                                  }}
                                />
                              </span>

                              <button
                                className='btn-ubbe-no-style'
                                onClick={() => {
                                  setSelectedItemId(item.id);
                                  setShowDeleteAlert(true);
                                }}
                              >
                                <img
                                  alt='delete-icon'
                                  src={deleteIcon}
                                  className='packageBoxIcon'
                                  style={{
                                    backgroundColor: 'rgba(252, 0, 0, 0.10)',
                                    cursor: 'pointer',
                                  }}
                                />
                              </button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : loading ? (
                    <tr className='text-center'>
                      <td colSpan={9}>
                        <div
                          className='spinner-border'
                          role='status'
                        >
                          <span className='visually-hidden'>Loading...</span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td
                        colSpan={9}
                        className='text-center global-text align-middle '
                        style={{ color: ' #979797                      ' }}
                      >
                        Saved Contacts not found! Please try again.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {savedContactData && savedContactData?.count > 9 && (
              <div className='d-flex align-items-center justify-content-end gap-3'>
                <PageSizeDropdown
                  setPageSize={setPageSize}
                  pageSizeOptions={pageSizeOptions}
                  currentSize={pageSize}
                  setCurrentPage={setCurrentPage}
                />
                <NewPaginationContainer
                  totalItems={savedContactData?.count}
                  totalPages={savedContactData?.pages}
                  currentPage={savedContactData?.current}
                  pageSize={savedContactData?.count}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {showAddModal && (
        <AddSavedContactModal
          onSuccess={() => {
            fetchData();
            onCloseModal();
          }}
          onClose={() => onCloseModal()}
        />
      )}
      {showEditModal && (
        <AddSavedContactModal
          onSuccess={() => {
            fetchData();
            onCloseModal();
          }}
          onClose={() => onCloseModal()}
          editData={editData}
        />
      )}
      {showDeleteAlert && (
        <AlertModal
          description={'Are you sure you want to delete?'}
          title='Delete Contact'
          confirmTitle={'Delete'}
          onClose={() => {
            setShowDeleteAlert(false);
            setSelectedItemId('');
          }}
          onSuccess={() => {
            deleteContact(selectedItemId);
          }}
        />
      )}
      {showAllDeleteAlert && (
        <AlertModal
          description={'Are you sure you want to delete?'}
          title='Delete Contacts'
          confirmTitle={'Delete Contacts'}
          onClose={() => {
            setShowAllDeleteAlert(false);
          }}
          onSuccess={() => {
            handleDeleteAll();
          }}
        />
      )}
      {showImportModal && (
        <ImportAddressModal
          onClose={() => setShowImportModal(false)}
          isContact={true}
        />
      )}
    </div>
  );
}

export default SavedContacts;
